import { render, staticRenderFns } from "./RateSection.vue?vue&type=template&id=db055d06&scoped=true&lang=html&"
import script from "./RateSection.vue?vue&type=script&lang=js&"
export * from "./RateSection.vue?vue&type=script&lang=js&"
import style0 from "./RateSection.vue?vue&type=style&index=0&id=db055d06&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db055d06",
  null
  
)

export default component.exports